import styled from 'styled-components'

export const InputNumberWrap = styled.div`
  width: 100%;
`
